import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-14 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            六大精选分类，快速找到您感兴趣的内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                {category.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden md:block">
                {category.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}